import { useNavigate } from "react-router-dom";
import Images from "../utils/Images";
import { clearSession } from "../utils/Api";

export default function AppHeader({ actions = null }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        clearSession();
        navigate("/", { replace: true });
    };

    return (
        <div className="sticky top-0 z-30 bg-[#09A5F7]/95 backdrop-blur-xl border-b border-[#4FC8FF] rounded-b-3xl">
            <div className="flex items-center justify-between gap-3 px-5 py-4">
                <img
                    src={Images.logo}
                    alt="Crewflow Logo"
                    className="object-contain w-[110px] h-12"
                />

                <div className="flex items-center gap-2">
                    {actions}

                    <button
                        type="button"
                        onClick={handleLogout}
                        aria-label="Log out"
                        className="w-11 h-11 rounded-full bg-[#F1FAFD] border border-[#DFEEF4] text-[#09A5F7] shadow-sm flex items-center justify-center"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M10 7V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-1" />
                            <path d="M15 12H4" />
                            <path d="M7 9L4 12l3 3" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}
